import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
//import { CLineDec } from "src/app/info-decorticage";

// Corriger les pb d'import avec le server

@Component({
    selector: 'dialog-content-example-dialog',
    templateUrl: 'dialog-content-example-dialog.html',
    styleUrls: ['dialog-content-example-dialog.css']
})
export class DialogContentExampleDialog {

    LineDec: /*CLineDec*/any;
    BackupLineDec: /*CLineDec*/any;

    constructor(public dialogRef: MatDialogRef<DialogContentExampleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.LineDec = this.data;
        this.BackupLineDec /*= new CLineDec()*/;
        this.BackupLineDec.update(this.LineDec);
    }

    public closeDialog() {
        this.dialogRef.close(false);
        this.LineDec.update(this.BackupLineDec);
    }

    public validerDialog() {
        this.dialogRef.close(this.LineDec);
    }
}